import { Pie, mixins } from 'vue-chartjs';

export default {
  name: 'pie-chart',
  mixins: [mixins.reactiveProp],
  extends: Pie,
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      delayed: false,
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData() {
      this.$data._chart.update();
    },
    options() {
      this.$options._chart.update();
    },
  },
};
